import { Set } from "immutable";

import { OUTLINE_ID_COLUMN_WIDTH, OUTLINE_LABEL_COLUMN_WIDTH, OUTLINE_SEQUENCE_COLUMN_WIDTH } from ".";

export const OUTLINE_COLUMN_BULK_CHANGE_DATES = "OUTLINE_COLUMN_BULK_CHANGE_DATES";

const outlineColumnIds = {
  label: "label",
  identifier: "identifier",
  sequence: "sequence",
  narrative: "narrative",
  summary: "summary",
  type: "type",
  color: "color",
  start: "start",
  latestStart: "latestStart",
  duration: "duration",
  earliestEnd: "earliestEnd",
  end: "end",
  childRange: "childRange",
  ongoing: "ongoing",
  blocks: "blocks",
  blockedBy: "blockedBy",
  property: "property",
  reference: "reference",
  tag: "tag"
};

const outlineColumnLabels = {
  label: "Label",
  identifier: "ID",
  sequence: "#",
  narrative: "Position",
  summary: "Summary",
  type: "Type",
  color: "Color",
  start: "Start Date",
  latestStart: "Latest Start Date",
  duration: "Duration",
  earliestEnd: "Earliest End Date",
  end: "End Date",
  childRange: "Child Range",
  ongoing: "Ongoing",
  blocks: "Blocks",
  blockedBy: "Blocked By",
  property: "property",
  reference: "reference",
  tag: "Tags"
};

// Do not scroll with other columns
const stickyColumnIds = [outlineColumnIds.label];

// Keep in the beginning position / index
// Eg. label is always the first column
const fixedColumnIds = [outlineColumnIds.label];

const fixedAndStickyColumnIds = Set(fixedColumnIds.concat(stickyColumnIds)).toJS();

const columnDefaultWidths = {
  [outlineColumnIds.label]: OUTLINE_LABEL_COLUMN_WIDTH + OUTLINE_ID_COLUMN_WIDTH,
  [outlineColumnIds.identifier]: OUTLINE_SEQUENCE_COLUMN_WIDTH,
  [outlineColumnIds.sequence]: OUTLINE_SEQUENCE_COLUMN_WIDTH
};

export { columnDefaultWidths, fixedAndStickyColumnIds, fixedColumnIds, outlineColumnLabels, stickyColumnIds };

export default outlineColumnIds;
